import { h as hasOwnProperty } from '../../LocalModules/storm-ui-utils/dist/esm/hasOwnProperty-BBa9GG4X-BBa9GG4X.js';

const isClickableListItem = item => !!(hasOwnProperty(item, 'type') && hasOwnProperty(item.type, 'displayName') && typeof item.type.displayName === 'string');

export { isClickableListItem as i };
//# sourceMappingURL=isClickableListItem-3xl9P76P.js.map
